import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams ,useSearchParams} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function OrdersMainTable() {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [goToPage, setGoToPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [sortable, setSortable] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("Pending");

  const { pageNo, serviceId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const status = searchParams.get("status") || "";

  useEffect(() => {
    const page = parseInt(pageNo) || 1;
    setCurrentPage(page);
    setGoToPage(page);
    getOrders(page);
  }, [pageNo]);

  useEffect(() => {
    getOrders(currentPage);
  }, [currentPage, recordsPerPage, serviceId]);

  const handleTableSort = (column) => {
    let order = "asc";
    if (column === sortable) {
      order = sortOrder === "asc" ? "desc" : "asc";
    }
    setSortable(column);
    setSortOrder(order);
    getOrders(currentPage, column, order);
  };

  const handlePrevious = () => {
    const prev = currentPage - 1;
    navigate(`/admin-panel/orders/${prev}`);
  };

  const handleNext = () => {
    const next = currentPage + 1;
    navigate(`/admin-panel/orders/${next}`);
  };

  const handleGoToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      navigate(`/admin-panel/orders/${page}`);
    } else {
      toast.error("Invalid page number");
    }
  };

  function formatDate(isoString) {
    const date = new Date(isoString);

    const day = date.getUTCDate(); 
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day}, ${month} ${year}`;
  }

  const getOrders = async (page = 1, sort = sortable, order = sortOrder) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/order/view-all-orders`,
        {
          headers,
          params: {
            serviceId,
            status,
            page,
            limit: recordsPerPage,
            sortField: sort,
            sortOrder: order,
          },
        }
      );

      const res = response.data;

      console.log("response", response);
      if (res.statusCode === 200) {
        setData(res.result.orders);
        setTotalRecords(res.result.totalRecords);
        setTotalPages(res.result.totalPages);
        setCurrentPage(res.result.currentPage);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to fetch orders");
      console.error(error);
    }
    setLoading(false);
  };

  const handleStatusUpdate = async (status) => {
    try {
      setLoading(true);
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("orderId", selectedOrderId);
      formdata.append("status", status);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/order/update-status`,
        formdata,
        { headers }
      );

      if (response.data.statusCode === 200) {
        toast.success(response.data.message);
        // navigate("/admin-panel/orders/1");
        getOrders();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update status. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
        <div className="flex justify-between items-center">
          <h2 className="md:text-xl text-base font-medium">Orders</h2>
          <div className="flex gap-4 items-center">
            <div className="flex flex-col">
              <span className="text-xs">Per Page</span>
              <select
                className="border border-gray-300 rounded-md text-sm px-2 py-1"
                value={recordsPerPage}
                onChange={(e) => setRecordsPerPage(Number(e.target.value))}
              >
                {[10, 20, 30, 50].map((val) => (
                  <option key={val} value={val}>
                    {val}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex flex-col">
              <span className="text-xs">Go to</span>
              <input
                type="number"
                className="border border-gray-300 rounded-md text-sm px-2 py-1 w-16"
                value={goToPage}
                onChange={(e) => setGoToPage(Number(e.target.value))}
                onBlur={() => handleGoToPage(goToPage)}
              />
            </div>
          </div>
        </div>

        <div className="overflow-auto mt-8 text-sm">
          <table className="w-full text-center">
            <thead>
              <tr className="border-b font-medium">
                <th
                  className="py-3 cursor-pointer"
                  // onClick={() => handleTableSort("orderId")}
                >
                  Date
                </th>
                <th
                  className="py-3 cursor-pointer"
                  // onClick={() => handleTableSort("orderId")}
                >
                  Family Id
                </th>
                <th
                  className="py-3 cursor-pointer"
                  // onClick={() => handleTableSort("email")}
                >
                  Customer Name
                </th>
                <th
                  className="py-3 cursor-pointer"
                  // /onClick={() => handleTableSort("orderId")}
                >
                  Order ID
                </th>
                {(serviceId === "67cde15df875ad8f161123ae" ||
                  serviceId === "67deed42f56f3e22dc5b82e8") && (
                  <th
                    className="py-3 cursor-pointer"
                    // onClick={() => handleTableSort("totalAmount")}
                  >
                    Return
                  </th>
                )}

                {/* <th className="py-3">Product</th> */}
                <th
                  className="py-3 cursor-pointer"
                  // onClick={() => handleTableSort("totalAmount")}
                >
                  Amount
                </th>
                <th
                  className="py-3 cursor-pointer"
                  // onClick={() => handleTableSort("status")}
                >
                  Status
                </th>
                <th className="py-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                data.length > 0 ? (
                  data.map((item) => (
                    <tr key={item._id} className="border-b">
                      <td className="py-3">{formatDate(item.createdAt)}</td>
                      <td className="py-3">{item?.user?._id}</td>
                      <td className="py-3">{item?.user?.firstName}</td>
                      <td className="py-3">
                        {item.orderId}
                        {item.isEmergency && (
                          <span className="ml-1 text-red-500 text-xs">🔴</span>
                        )}
                      </td>
                      {/* <td className="py-3">{item.email}</td> */}
                      {/* <td className="py-3">{item.product?.name || "—"}</td> */}
                      {(serviceId === "67cde15df875ad8f161123ae" ||
                        serviceId === "67deed42f56f3e22dc5b82e8") && (
                        <td className="py-3">{item.quantity}</td>
                      )}

                      <td className="py-3">{item.totalAmount}</td>
                      <td className="py-3">{item.status}</td>
                      <td className="py-3 ">
                        <button
                          className="bg-green-600 text-white w-[36px] h-[36px] rounded-full"
                          title="View Order"
                          onClick={() => {
                            navigate(`/admin-panel/order/view/${item._id}`, {
                              state: { data: item },
                            });
                          }}
                        >
                          <i className="fa fa-eye"></i>
                        </button>
                        <button
                          type="button"
                          className="bg-blue-600 text-white w-[36px] h-[36px] rounded-full ml-2"
                          data-toggle="modal"
                          data-target="#exampleModal"
                          onClick={() => {
                            setSelectedOrderId(item._id);
                          }}
                        >
                          <i className="fa fa-edit" />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="py-6 text-center">
                      No results found.
                    </td>
                  </tr>
                )
              ) : (
                <tr>
                  <td colSpan="6" className="py-6 text-center">
                    Loading...
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="flex justify-between items-center mt-6">
          <span className="text-xs text-gray-600">
            Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
            {Math.min(currentPage * recordsPerPage, totalRecords)} of{" "}
            {totalRecords}
          </span>
          <div className="flex items-center gap-3">
            <button
              className="px-3 py-1 bg-gray-700 text-white rounded disabled:opacity-40"
              disabled={currentPage === 1}
              onClick={handlePrevious}
            >
              <i className="fa fa-chevron-left"></i>
            </button>
            <span className="text-sm">
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="px-3 py-1 bg-gray-700 text-white rounded disabled:opacity-40"
              disabled={currentPage === totalPages}
              onClick={handleNext}
            >
              <i className="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Modal */}

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Edit Order Status
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <select
                className="form-control"
                onChange={(e) => setSelectedStatus(e.target.value)}
                value={selectedStatus}
              >
                <option value="Pending">Pending</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
                <option value="Out for Delivery">Out for Delivery</option>
                <option value="REASSIGNED_FOR_DELIVERY">REASSIGNED_FOR_DELIVERY</option>
              </select>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-success"
                onClick={() => handleStatusUpdate(selectedStatus)}
                data-dismiss="modal"
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
